/* =========================================
   POLICY PAGES LOGIC & ANIMATIONS
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {

    // 1. PAGE LOAD ANIMATIONS
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        let mm = gsap.matchMedia();
        
        mm.add("(prefers-reduced-motion: no-preference)", () => {
            const tl = gsap.timeline({ defaults: { ease: 'power3.out', duration: 0.8 } });
            
            // Waterfall reveal the layout
            tl.fromTo('.escape-hatch-banner', { opacity: 0, y: -10 }, { opacity: 1, y: 0, delay: 0.1 })
              .fromTo('.policy-header', { opacity: 0, y: 30 }, { opacity: 1, y: 0 }, "-=0.6")
              .fromTo('.policy-content', { opacity: 0, y: 30 }, { opacity: 1, y: 0 }, "-=0.6")
              .fromTo('.sidebar-action-box', { opacity: 0, x: 20 }, { opacity: 1, x: 0 }, "-=0.6")
              .fromTo('.sidebar-sticky', { opacity: 0, x: 20 }, { opacity: 1, x: 0 }, "-=0.6");
        });
    }

    // 2. TOC SCROLL SPY (Active State Highlighting)
    const headings = document.querySelectorAll('.policy-content h2[id]');
    const tocLinks = document.querySelectorAll('.toc-nav ul li a');

    if (headings.length > 0 && tocLinks.length > 0) {
        // Intersection Observer options
        const observerOptions = {
            root: null,
            rootMargin: '-130px 0px -70% 0px', 
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    tocLinks.forEach(link => link.classList.remove('active'));
                    const id = entry.target.getAttribute('id');
                    const activeLink = document.querySelector(`.toc-nav ul li a[href="#${id}"]`);
                    if (activeLink) {
                        activeLink.classList.add('active');
                    }
                }
            });
        }, observerOptions);

        headings.forEach(heading => observer.observe(heading));

        // 3. PREVENT HISTORY POLLUTION ON TOC CLICKS
        // Smooth scroll and use replaceState so the "Back" button always leaves the page
        tocLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = link.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                    // Update URL hash without adding a new entry to the browser's back history
                    history.replaceState(null, '', targetId);
                }
            });
        });
    }
});
